import Immutable, { fromJS } from 'immutable';

import {
  INITIALIZE_REGISTRATIONS,
  REGISTRATION_DELETED,
  RESET_REGISTRATIONS,
  REGISTRATION_STATISTICS_LOADED,
  initializeRegistrationDates,
  REGISTRATION_OVERVIEW_LOADED,
} from '../../actions/Registrations';

const initialState = fromJS({
  registrationsStartDate: null,
  programStartDate: null,
  registrations: {},
  outstandingRegistrations: [],
  isRecoveryPlanSet: false,
  isInitialLoaded: false,
  streaks: {
    total: null,
    completed: null,
    success: null,
    failed: null,
  },
});

export default function registrations(state = initialState, action = {}) {
  switch (action.type) {
    case INITIALIZE_REGISTRATIONS: {
      const registrationsStartDate = new Date(action.registrationsStartDate);
      const programStartDate = new Date(action.programStartDate);
      const registrations = initializeRegistrationDates(registrationsStartDate, programStartDate);

      return state
        .set('registrationsStartDate', registrationsStartDate)
        .set('programStartDate', programStartDate)
        .set('registrations', Immutable.OrderedMap(registrations));
    }

    case REGISTRATION_OVERVIEW_LOADED: {
      const outstandingRegistrations = Object.entries(action.payload)
        .filter(([date, registration]) => (
          registration.totalAmount === null &&
          new Date(date).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
        ))
        .map(([date]) => date);

      const isRecoveryPlanSet = Object.values(action.payload)
        .some((registration) => registration.goal !== null);

      return state
        .set('registrations', Immutable.OrderedMap(action.payload))
        .set('outstandingRegistrations', Immutable.OrderedSet(outstandingRegistrations))
        .set('isRecoveryPlanSet', isRecoveryPlanSet)
        .set('isInitialLoaded', true);
    }

    case REGISTRATION_STATISTICS_LOADED: {
      return state.set('streaks', action.payload);
    }

    case REGISTRATION_DELETED: {
      const { date, uuid } = action;
      const registrationsForDate = state.getIn(['registrations', date], {});

      if (!registrationsForDate.items) {
        return state;
      }

      const { [uuid]: _deletedRegistration, ...registrations } = registrationsForDate.items;
      const newRegistrationsForDate = {
        ...registrationsForDate,
        items: registrations,
      };

      const newState = state
        .get('registrations', Immutable.OrderedMap())
        .merge({ [date]: newRegistrationsForDate });

      return state.set('registrations', newState);
    }

    case RESET_REGISTRATIONS: {
      return initialState;
    }

    default:
      return state;
  }
}
